import getStore from 'services/getStore';

const store = getStore();

const shouldUpdate = () => {
  if (window.dev && !window.dev()) {
    return true;
  }

  const { focusedNodeId, blocks } = store.getState();
  const { type } = blocks[focusedNodeId] || {};

  const typeIsText = type ? type.toLowerCase() === 'text' : undefined;

  return typeIsText;
};

export default shouldUpdate;
